import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';

import RotatableEntity from '../../../../../../common/records/RotatableEntity';
import CategoryContent, { AtlassianProductDiversion } from '../records/CategoryContent';
import CategoryMetadata from '../records/CategoryMetadata';

import type { List } from 'immutable';

const metaImage = PropTypes.string;

const heading = ImmutablePropTypes.contains({
  image: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
});

const callToActionText = PropTypes.string;

const curatedApps = PropTypes.instanceOf(RotatableEntity);

export default {
  solutionContent: PropTypes.instanceOf(CategoryContent),
  atlassianProductDiversion: PropTypes.instanceOf(AtlassianProductDiversion),
  metaImage,
  heading,
  callToActionText,
  curatedApps,
  categoriesMetadata: ImmutablePropTypes.listOf(PropTypes.instanceOf(CategoryMetadata)),
};

export type CategoriesMetadata = List<typeof CategoryMetadata>;
